export default __webpack_public_path__ + "static/media/screenshot-05.ff22e683.jpg";